import { Player } from '../entities/Player';
import { SpriteType } from '../entities/SpriteType';
import { DrawEvent } from '../events/draw/DrawEvent';
import { PlayerJoinBarEvent } from '../events/playerJoinBar/PlayerJoinBarEvent';
import { defaultPlayerSize } from '../tests/testContexts';
export class PlayerApplicationService {
    constructor(playerRepository, eventGateway) {
        this.playerRepository = playerRepository;
        this.eventGateway = eventGateway;
    }
    playerByUsername(username) {
        return this.playerRepository.playerByUsername(username);
    }
    updatePosition(username, position, size) {
        return this.playerRepository.playerByUsername(username)
            .then(player => this.playerRepository.save(new Player(Object.assign(Object.assign({}, player.toDto()), { position }))))
            .then(() => this.eventGateway.sendEvent(new DrawEvent(username, { position, size, spriteType: SpriteType.PLAYER })))
            .catch(error => Promise.reject(error));
    }
    players() {
        return this.playerRepository.loadAllPlayers();
    }
    removePlayer(player) {
        return this.playerRepository.remove(player);
    }
    addPlayer(username) {
        return this.playerRepository.hasPlayer(username)
            .then(hasPlayer => hasPlayer ? Promise.resolve() : this.onNewPlayer(username))
            .catch(error => Promise.reject(error));
    }
    onNewPlayer(username) {
        return this.playerRepository.save(new Player({ username, size: defaultPlayerSize }))
            .then(() => this.eventGateway.sendEvent(new PlayerJoinBarEvent(username)))
            .catch(error => Promise.reject(error));
    }
}
